import { EVENT } from '../constants'
import { GA4Event, GA4GeneralProps } from '../GA4Event'

export interface GA4SerpResultSelectedEventProps extends GA4GeneralProps {
  componentClass: string
  componentName: string
  resultPosition?: number | null
  resultPage?: number | null
  selectedOption?: string | null
}

export class GA4SerpResultSelectedEvent extends GA4Event {
  ga4_selected_option: string | null
  ga4_result_position: number | null
  ga4_result_page: number | null

  constructor({
    resultPosition = null,
    resultPage = null,
    selectedOption = null,
    ...generalProps
  }: GA4SerpResultSelectedEventProps) {
    super({ event: EVENT.SERP_RESULT_SELECTED, ...generalProps })

    this.ga4_result_position = resultPosition
    this.ga4_result_page = resultPage
    this.ga4_selected_option = selectedOption
  }
}
